export const turboScroll = function () {
  Turbolinks.scroll || (Turbolinks.scroll = {});

  const elements = document.querySelectorAll("[data-turbolinks-scroll]");

  if (document.scrollingElement) {
    elements.forEach(function (element) {
      element.addEventListener("click", function () {
        Turbolinks.scroll['top'] = document.scrollingElement.scrollTop;
      });
      element.addEventListener("submit", function () {
        Turbolinks.scroll['top'] = document.scrollingElement.scrollTop;
      });
    });

    if (Turbolinks.scroll['top']) {
      document.scrollingElement.scrollTo(0, Turbolinks.scroll['top']);
    }
  }

  Turbolinks.scroll = {};
}